<div
  class="dgrilla"
  cdkDropList
  cdkDropListOrientation="mixed"
  (cdkDropListDropped)="soltar($event)"
>
  @for (item of items(); track item.id) {
    <div
      class="dgrilla-item"
      [class.dgrilla-item--ancho]="item.ancho === 'ancho'"
      [class.dgrilla-item--completo]="item.ancho === 'completo'"
      cdkDrag
    >
      <div
        class="dgrilla-manija"
        cdkDragHandle
        matTooltip="Arrastrá para reordenar"
      >
        <mat-icon>drag_indicator</mat-icon>
      </div>
      <ng-container
        *ngTemplateOutlet="plantilla; context: { $implicit: item }"
      ></ng-container>
    </div>
  }
</div>
